import { Button } from '@nexelem/components';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useCustomTranslation } from '../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';

export type ActionsFormProps = {
  isFirstStep: boolean;
  isLastStep: boolean;
  translationRoot: 'offers' | 'orders' | 'products';
  previousStepName: string;
  cancelURL: string;
  onClickNext: () => void;
  onClickSaveDraft?: () => void;
  backUrl?: string;
};

export const FormStepperActions: FC<ActionsFormProps> = ({
  onClickNext,
  onClickSaveDraft,
  isFirstStep,
  previousStepName,
  isLastStep,
  cancelURL,
  translationRoot,
  backUrl,
}) => {
  const { tWrapper } = useCustomTranslation('components.stepperForm');

  return (
    <>
      <Button component={Link} to={cancelURL} variant="text">
        {tWrapper('cancel')}
      </Button>
      {!isFirstStep && backUrl && (
        <Button component={Link} StartIcon={<FontAwesomeIcon icon={faArrowLeft} />} to={backUrl} variant="outlined">
          {tWrapper('back', { previousStepName })}
        </Button>
      )}
      {!!onClickSaveDraft && (
        <Button variant="outlined" onClick={onClickSaveDraft}>
          {tWrapper('draft')}
        </Button>
      )}
      {!isLastStep && (
        <Button EndIcon={<FontAwesomeIcon icon={faArrowRight} />} variant="contained" onClick={onClickNext}>
          {tWrapper('next')}
        </Button>
      )}
      {isLastStep && (
        <Button variant="contained" onClick={onClickNext}>
          {tWrapper(`submit.${translationRoot}`)}
        </Button>
      )}
    </>
  );
};
